import { render, staticRenderFns } from "./DemandType.vue?vue&type=template&id=5935b6a5&scoped=true&"
import script from "./DemandType.vue?vue&type=script&lang=js&"
export * from "./DemandType.vue?vue&type=script&lang=js&"
import style0 from "./DemandType.vue?vue&type=style&index=0&id=5935b6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935b6a5",
  null
  
)

export default component.exports